import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import {endOfToday} from "date-fns";


const PaymentMenu = ({booking, openFormPayment, disabled=false}) => {
    const [paymentMenuEl, setPaymentMenuEl] = React.useState(null);
    const openMenu = Boolean(paymentMenuEl);

    const bookingFinance = booking.bookingFinance;
    const showAddRefund = bookingFinance.totalPayed > 0;

    const addDepositPayment = (deposit) => () => {
        openFormPayment('incoming', deposit, 'deposit');
    }

    const addBalancePayment = (balance) => () => {
        openFormPayment('incoming', balance, 'balance');
    }

    const getDefaultPayment = () => {
        if (bookingFinance.deposit && bookingFinance.deposit > bookingFinance.totalPayed && booking.getArrival() > endOfToday()) {
            const diff = bookingFinance.deposit - bookingFinance.totalPayed;
            return ["Salda caparra", addDepositPayment(diff)];
        }

        if (bookingFinance.totalPrice && bookingFinance.totalPrice > bookingFinance.totalPayed) {
            return ["Salda conto", addBalancePayment(bookingFinance.balance)];
        }

        return [null, null];
    }

    const [paymentLabel, paymentHandler] = getDefaultPayment();

    const addPayment = () => {
        openFormPayment('incoming');
    }

    const addRefund = () => {
        openFormPayment('outgoing', null, 'refund');
    }

    const handleOpenMenu = (event) => {
        if(!showAddRefund && !paymentHandler && !paymentLabel) {
            addPayment();
        } else {
            setPaymentMenuEl(event.currentTarget);
        }
    };

    const handleCloseMenu = () => {
        setPaymentMenuEl(null);
    };

    const handleSelectMenuItem = (action) => () => {
        setPaymentMenuEl(null);
        action();
    };

    return (
        <>
            <Button id="payment-menu-button"
                    size="small"
                    aria-controls="payment-menu"
                    edge="end"
                    aria-haspopup="true"
                    aria-expanded={openMenu ? 'true' : undefined}
                    onClick={handleOpenMenu}
                    startIcon={<AddIcon fontSize="inherit"/>}>
                Aggiungi
            </Button>

            <Menu id="payment-menu"
                  anchorEl={paymentMenuEl}
                  open={openMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{'aria-labelledby': 'payment-menu-button',}}>
                {
                    paymentHandler && paymentLabel && <MenuItem onClick={handleSelectMenuItem(paymentHandler)}
                                                                disabled={disabled}>{paymentLabel}</MenuItem>
                }
                <MenuItem onClick={handleSelectMenuItem(addPayment)} disabled={disabled}>Nuovo pagamento</MenuItem>
                {
                    showAddRefund  &&
                    <MenuItem onClick={handleSelectMenuItem(addRefund)} disabled={disabled}>Nuovo rimborso</MenuItem>
                }
            </Menu>
        </>
    );
}


export default PaymentMenu;